import React from 'react';
import './data-card.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';

const DataCard = ({
    icon,
    data,
    text,
    onclick,
    role
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);

    return (
        <div className='data-card-container'>
            {
                (onclick && (role === 'owner' || role === 'manager' || role === 'distributor')) 
                ?
                <button 
                    className='g-button g-card'
                    onClick={onclick}
                >
                    <div className={`data-card ${screenSize}`}>
                        <div className='icon-container'>
                            <div className='icon-circle'>
                                <FontAwesomeIcon icon={icon} size={screenSize === 'mobile' ? 'sm' : 'xl'} />
                            </div>
                        </div>
                        <div className={`data-div ${screenSize}`}>
                            <div className='data-number'>
                                {data}
                            </div>
                            <div className='data-text'>
                                {text}
                            </div>
                        </div>
                    </div>
                </button>
                :
                <div className='g-card'>
                    <div 
                        className={`data-card ${screenSize}`}
                    >
                        <div className='icon-container'>
                            <div className='icon-circle'>
                                <FontAwesomeIcon icon={icon} size={screenSize === 'mobile' ? 'm' : 'xl'} />
                            </div>
                        </div>
                        <div className={`data-div ${screenSize}`}>
                            <div className='data-number'>
                                {data}
                            </div>
                            <div className='data-text'>
                                {text}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default DataCard